import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCallHistorys
} from "../../services/callHistoryService";
import { toast } from "react-toastify";

const initialState = {
  callHistorys: [],
  total: 0,
  page: 1,
  status: "idle",
  error: null,
};

// Fetch all callHistorys - UPDATE TO ACCEPT PARAMS OBJECT
export const fetchCallHistorys = createAsyncThunk(
  "callHistorys/fetchCallHistorys",
  async (params = {}, { rejectWithValue }) => { // Accept params as object
    try {
      const response = await getCallHistorys(params); // Pass entire params object
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to fetch call history";
      toast.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

const callHistorySlice = createSlice({
  name: "callHistorys",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetCallHistoryState: (state) => {
      state.callHistorys = [];
      state.total = 0;
      state.page = 1;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch CallHistorys
      .addCase(fetchCallHistorys.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCallHistorys.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.callHistorys = action.payload.data?.callHistory || action.payload.data || [];
        state.total = action.payload.data?.total || action.payload.total || 0;
        state.page = action.payload.data?.page || action.payload.data?.currentPage || action.payload.page || 1;
        state.error = null;
      })
      .addCase(fetchCallHistorys.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.callHistorys = [];
        state.total = 0;
        state.page = 1;
      })
  },
});

export const { clearError, resetCallHistoryState } = callHistorySlice.actions;

// Selectors
export const selectAllCallHistorys = (state) => state.callHistorys.callHistorys;
export const selectCallHistoryStatus = (state) => state.callHistorys.status;
export const selectCallHistoryError = (state) => state.callHistorys.error;
export const selectCallHistoryTotal = (state) => state.callHistorys.total;
export const selectCallHistoryPage = (state) => state.callHistorys.page;

export default callHistorySlice.reducer;